import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'transfer/utils/p2p-connect'
import Overpanel from 'react-components/overpanel'
import CIPManualReview from './manual-review'
import { CIP } from '../../constants'
import CIPSuccess from './cip-success'
import CIPError from './cip-error'

export class CIPOverpanels extends React.Component {
  static propTypes = {
    cipStatus: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)
    const { cipStatus } = props
    this.state = {
      showManualReviewOverpanel: cipStatus === CIP.MANUAL_REVIEW,
      showErrorOverpanel: cipStatus === CIP.CIP_ERROR,
      showSuccessOverpanel: cipStatus === CIP.VERIFIED,
    }
  }

  toggleManualReviewOverpanel = () => {
    this.setState({
      showManualReviewOverpanel: !this.state.showManualReviewOverpanel,
    })
  }

  toggleSuccessOverpanel = () => {
    this.setState({
      showSuccessOverpanel: !this.state.showSuccessOverpanel,
    })
  }

  toggleErrorOverpanel = () => {
    this.setState({
      showErrorOverpanel: !this.state.showErrorOverpanel,
    })
  }

  render() {
    const {
      showManualReviewOverpanel,
      showErrorOverpanel,
      showSuccessOverpanel,
    } = this.state
    return (
      <div>
        <Overpanel
          show={showManualReviewOverpanel}
          handleClose={this.toggleManualReviewOverpanel}
        >
          <CIPManualReview handleNext={this.toggleManualReviewOverpanel} />
        </Overpanel>
        <Overpanel
          show={showSuccessOverpanel}
          handleClose={this.toggleSuccessOverpanel}
        >
          <CIPSuccess handleNext={this.toggleSuccessOverpanel} />
        </Overpanel>
        <Overpanel
          show={showErrorOverpanel}
          handleClose={this.toggleErrorOverpanel}
        >
          <CIPError handleNext={this.toggleErrorOverpanel} />
        </Overpanel>
      </div>
    )
  }
}

export default connect(({ external }) => ({
  cipStatus: external.cipStatus,
}))(CIPOverpanels)
